<template>
  <footer class="footer">
    <span>&copy; {{year}} <a href="https://davidlares.com">David E Lares S</a> | All rights reserved</span>
  </footer>
</template>
<script>
export default {
  name: 'Footer',
  data() {
    return {
      year: new Date().getFullYear()
    }
  }
}
</script>
